import { z } from 'zod';

/**
 * Concept — PRD menyebutnya di pipeline §17 ("Product → Prompt Intelligence →
 * Concepts → Storyboard") dan endpoint §23 (POST /api/bff/concepts), TAPI TIDAK
 * memberi schema field eksplisit. Bentuk di bawah adalah desain kami:
 * beberapa "arah kreatif" alternatif (biasanya 3) hasil LLM dari master prompt,
 * user pilih satu sebagai dasar storyboard.
 */
export const conceptSchema = z.object({
  id: z.string().min(1),
  productId: z.string().min(1),
  promptPackageId: z.string().min(1).nullable().optional(),
  title: z.string().min(1),
  hook: z.string().min(1),
  angle: z.string().min(1).describe('Ringkasan arah kreatif: sudut pandang, mood, kenapa ini akan efektif'),
  createdAt: z.string(),
});
export type Concept = z.infer<typeof conceptSchema>;

/**
 * Output LLM generate_concepts — array beberapa opsi sekaligus dalam satu panggilan.
 *
 * Field `.describe()` dikirim ke model via JSON Schema (response_format) sehingga
 * model mendapat guidance kualitas di level schema, bukan hanya dari system prompt.
 */
export const generateConceptsOutputSchema = z.object({
  concepts: z
    .array(
      z.object({
        title: z
          .string()
          .min(1)
          .describe(
            'Nama concept yang imajinatif dan spesifik, mencerminkan esens kreatifnya. ' +
            'Contoh: "Morning Ritual Awakening", "Pain-to-Power Transformation", "The Secret She Keeps".',
          ),
        hook: z
          .string()
          .min(1)
          .describe(
            'KALIMAT PEMBUKA LENGKAP yang diucapkan/ditampilkan di 3 detik pertama video. ' +
            'Harus kuat, emosional, atau mengejutkan — langsung menarik perhatian. ' +
            'BUKAN deskripsi meta — tulis KATA-KATA ASLI yang digunakan. Min 1-2 kalimat penuh. ' +
            'Contoh BAIK: "Sebelum kamu menyerah dengan kulitmu sendiri, ada satu hal yang belum kamu coba." ' +
            'Contoh BURUK: "Tunjukkan seseorang yang bangun pagi"',
          ),
        angle: z
          .string()
          .min(1)
          .describe(
            'Penjelasan DETAIL tentang sudut pandang kreatif — min 4 kalimat yang mencakup: ' +
            '(1) inti pesan emosional yang ingin disampaikan, ' +
            '(2) target audiens yang paling resonan dan alasannya, ' +
            '(3) emotional journey penonton dari awal sampai akhir video, ' +
            '(4) kenapa angle ini efektif untuk produk ini secara spesifik.',
          ),
      }),
    )
    .min(1)
    .max(5),
});
export type GenerateConceptsOutput = z.infer<typeof generateConceptsOutputSchema>;

export const createConceptsInputSchema = z.object({
  productId: z.string().min(1),
  promptPackageId: z.string().min(1).optional(),
  // jobId opsional — kalau disertakan, conceptIds baru akan disimpan di mockResult
  // job tersebut supaya GET /concepts?jobId= bisa filter konsep milik job ini saja.
  jobId: z.string().min(1).optional(),
  count: z.number().int().min(1).max(5).default(1),
});
export type CreateConceptsInput = z.infer<typeof createConceptsInputSchema>;
